export default "__VITE_ASSET__SvyJE982__"